export default __webpack_public_path__ + "static/media/unleashtheunderworld.c3f6e2f7.png";